import React from 'react'

const MySvgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <defs>
        <clipPath id='master_svg0_70_5872'>
          <rect x='0' y='0' width='20' height='20' rx='0' />
        </clipPath>
      </defs>
      <g clipPath='url(#master_svg0_70_5872)'>
        <g>
          <g>
            <path
              d='M0.9999809265136719,13.010665367736816L6.243970926513672,18.215075367736816L6.243970926513672,15.223255367736815L12.214880926513672,15.223255367736815L12.214880926513672,10.798085367736817L6.243970926513672,10.798085367736817L6.243970926513672,7.806275367736816L0.9999809265136719,13.010665367736816Z'
              fill='#333333'
              fillOpacity='1'
              style={{ mixBlendMode: 'passthrough' }}
            />
          </g>
          <g>
            <path
              d='M13.755988219299317,2L13.755988219299317,4.99181L7.783448219299316,4.99181L7.783448219299316,9.41539L13.755988219299317,9.41539L13.755988219299317,12.4088L18.999948219299316,7.20439L13.755988219299317,2Z'
              fill='#333333'
              fillOpacity='1'
              style={{ mixBlendMode: 'passthrough' }}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
